import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';
import { queryClient } from '../../queryClient';

interface TransitProps {
  id: string;
}

export const useGenerateTransitFollowLetter = () => {
  return useMutation({
    mutationFn: async ({ id }: TransitProps) => {
      await request({
        path: `transits/generate-ncts-follow-letter`,
        method: 'POST',
        authenticate: true,
        fileDownload: true,
        dataObject: { transitId: id },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
